<template>
  <v-card width="300">
    <v-card-text class="pa-2 caption black--text">
      <v-component
        v-for="heatmap in list"
        :key="heatmap.id"
        :is="heatmap.type"
        :heatmap="heatmap"
        :map="map"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  components: {
    heatmap: () => import('./slider.vue'),
    hex: () => import('./colors.vue')
  },
  props: {
    map: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    addHeatmap (data) {
      this.list.push(data)
    },
    updateHeatmap (index, data) {
      this.$set(this.list, index, data)
    },
    removeHeatmap (data) {
      const index = this.list.findIndex(val => val.id === data.id)
      if (index !== -1) {
        this.$delete(this.list, index)
      }
    }
  }
}
</script>